export default "__VITE_ASSET__D84DuY8W__"